module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-en-US.a7e76c98.jpg";